/**
 * Extracts unique competitor variable names from the given list of dashboard variables.
 */
export const getCompetitorVariables = (
    dashboardVariables: { variableName: string; competitor?: boolean }[],
): string[] => {
    const competitorNames = new Set<string>();
    for (const variable of dashboardVariables) {
        if (variable.competitor) {
            competitorNames.add(variable.variableName);
        }
    }
    return Array.from(competitorNames);
};
